import React, { useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { typesEventCrumbs } from '../constants';
import { useNavigate, useParams } from 'react-router-dom';
import TypesEventForm from 'system/components/types-event/form';
import { HttpResponse } from 'shell/models/http-response';
import { TypeEvent } from 'shell/models/type-event';
import { transformTypeEvent, transformTypeEventResponse } from '../utils/transform-type-event';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';
import { transformRequestTypeEvent } from '../utils/transform-type-event-request';

const TypesEventEditPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/tipievento');
  };

  const params = useParams();
  const [typeEvent] = useHttpFetch<HttpResponse<TypeEvent>, transformTypeEventResponse>(
    `${__OPERATION__EVENT__ADMIN__}/tipoEvento/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformTypeEvent,
    }
  );

  const updateTypeEvent = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/tipoEvento`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });
  const onSubmit = useCallback((formValues) => {
    const updateData = transformRequestTypeEvent(formValues);
    (
      updateTypeEvent({
        data: {
          ...updateData,
          noteUltimoAggiornamento: '',
        },
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/tipievento');
    });
  }, []);

  return (
    <>
      <Breadcrumbs items={[...typesEventCrumbs, { name: 'Modifica Tipo/Evento' }]} />
      <TypesEventForm
        forminitialValues={typeEvent?.data as transformTypeEventResponse}
        onOk={onSubmit}
        title="Modifica"
        onCancel={onCancel}
        isEdit
      />
    </>
  );
};
TypesEventEditPage.displayName = 'Edit single event  type page';
export default TypesEventEditPage;
